import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../../components/TemplateDashboard";
import PlantillasEntregasDetalleContent from './components/PlantillasEntregasDetalleContent';

const PlantillasEntregasDetalle = () => {

    return (
        <>

            <TemplateDashboard>
                <PlantillasEntregasDetalleContent />
            </TemplateDashboard>

        </>
    )
};

export default PlantillasEntregasDetalle;